<micro-picklist title="Sites" [all]="all" [(selectedIds)]="selectedItems" (selectedIdsChange)="onNgModelChange($event)"></micro-picklist>

